import { SidebarSectionController } from './sidebarSection.controller';
import template from './sidebarSection.html';

export const sidebarSectionComponent = {
  name: 'sidebarSectionComponent',
  restrict: 'E',
  template,
  transclude: true,
  controller: SidebarSectionController,
  controllerAs: 'vm',
  bindings: {
    id: '@',
    icon: '@',
    name: '@',
    nameValues: '<',
    sectionTitle: '@?',
    sectionTitleValues: '<',
    action: '&?',
    bubble: '@',
    disabled: '<',
    status: '<',
    isLoading: '<',
  },
};
